<template>
  <div class="row">
    <div class="col-12">
      <card class="custom-shadow-card-header">
        <div class="row content-add-btn">
          <header-add
            :typeEvent="1"
            route="/quality/boxinspections/create"
            v-if="isCreate()"
          />
        </div>

        <!-- Sección de filtros con filter-component -->
        <div v-if="isIndex()" class="px-3">
          <el-collapse v-model="activeName" @change="handleCollapse">
            <el-collapse-item :title="titleFilter" name="filter">
              <filter-component
                @filter="handleFilter"
                @showHideLoading="showHideLoading"
                :filterOfLots="false"
                :filterOfFarms="false"
              >
                <template slot="prev">
                  <select-component
                    class="pt-3"
                    :rowClass="`col-12 col-sm-6 col-xl-3`"
                    :labelSelect="`${$t(
                      'boxinspection.inspection_location'
                    )}: `"
                    :dataOptions="locations"
                    :initialSelection="dataFilter.location_ids"
                    @onChange="handleChangeSelected"
                    modelName="location_ids"
                  />
                  <select-component
                    class="pt-3"
                    :rowClass="`col-12 col-sm-6 col-xl-4`"
                    :labelSelect="`${$t('common_words.farms')}: *`"
                    :dataOptions="farms"
                    :requireClass="`required-farm-id`"
                    :initialSelection="dataFilter.farm_ids"
                    @onChange="handleChangeSelected"
                    modelName="farm_ids"
                  />
                </template>
              </filter-component>
            </el-collapse-item>
          </el-collapse>
        </div>

        <!-- Tabla de datos (solo se muestra si hay datos filtrados) -->
        <div v-if="isIndex()">
          <div v-if="tableData.length > 0">
            <card-header
              :propPagination="pagination"
              @searchedQuery="handleSearchQuery"
              class="mr-3 mt-4"
            >
              <template slot="between">
                <img
                  v-tooltip.top-center="$t('common_words.geo_location_map')"
                  style="width: 30px; height: 30px"
                  class="pointer"
                  src="/static/img/iconos/map.svg"
                  :alt="$t('common_words.geo_location_icon')"
                  @click="handleViewSamplesMap()"
                />
              </template>
            </card-header>
            <master-table
              :infoTable="queriedData"
              :columns="tableColumns"
              :showColumnStatus="false"
            >
              <template slot="addColumnsOperations">
                <table-columns-operations
                  v-if="isShow()"
                  @handleView="handleView"
                  @handleEdit="handleEdit"
                  @handleDelete="handleDelete"
                  :showOperationEdit="isUpdate()"
                  :canDisable="false"
                  :canDelete="true"
                  :minWidth="100"
                  :viewingRecordId="rowData ? rowData.id : null"
                />
              </template>
            </master-table>
            <card-footer ref="cardfooter" :propPagination="pagination" />
          </div>
        </div>
        <div v-if="showBoxDetails && rowData && rowData.box_inspection_boxes">
          <hr class="mx-3" />
          <div class="col-12 text-center">
            <em
              class="nc-icon nc-stre-up"
              style="font-size: 25px; cursor: pointer"
              @click="handleViewDetails"
              v-tooltip.top-center="$t('common_words.hide_detail')"
            ></em>
          </div>
          <div class="col-12 mt-2">
            <p style="font-size: 17px" class="text-muted">
              {{ $t('common_words.inspection_related_information') }}:
            </p>
          </div>

          <!-- Tabla de datos de la inspección -->
          <div class="col-12 mt-3">
            <table aria-describedby="table-details" class="table">
              <tbody>
                <!-- Fila 1: Finca, Caja -->
                <tr class="shadow-sm">
                  <td colspan="3" style="width: 50%">
                    <h6>
                      <strong>{{ $t('common_words.farm') }}:</strong>
                    </h6>
                    {{
                      rowData.farm
                        ? `${rowData.farm.id} - ${rowData.farm.name}`
                        : '-'
                    }}
                  </td>
                  <td colspan="3" style="width: 50%">
                    <h6>
                      <strong>{{ $t('production.box') }}:</strong>
                    </h6>
                    {{
                      rowData.box
                        ? `${rowData.box.code} - ${rowData.box.name}`
                        : '-'
                    }}
                  </td>
                </tr>
                <!-- Fila 2: Cant. Cajas, # Pallet, Ubicación, Fecha, Cajas Rechazadas, Usuario -->
                <tr class="shadow-sm">
                  <td>
                    <h6>
                      <strong>{{ $t('production.boxes_quantity') }}:</strong>
                    </h6>
                    {{
                      rowData.boxes_quantity
                        ? formatNumber(rowData.boxes_quantity)
                        : '-'
                    }}
                  </td>
                  <td>
                    <h6>
                      <strong># Pallet:</strong>
                    </h6>
                    {{ rowData.number_pallet || '-' }}
                  </td>
                  <td>
                    <h6>
                      <strong
                        >{{ $t('boxinspection.inspection_location') }}:</strong
                      >
                    </h6>
                    {{
                      rowData.location_inspection
                        ? rowData.location_inspection.name
                        : '-'
                    }}
                  </td>
                  <td>
                    <h6>
                      <strong>{{ $t('common_words.date') }}:</strong>
                    </h6>
                    {{
                      rowData.date_save ? formatDate(rowData.date_save) : '-'
                    }}
                  </td>
                  <td>
                    <h6>
                      <strong>{{ $t('production.rejected_boxes') }}:</strong>
                    </h6>
                    {{
                      rowData.boxes_rejected
                        ? formatNumber(rowData.boxes_rejected)
                        : '0'
                    }}
                  </td>
                  <td>
                    <h6>
                      <strong>{{ $t('common_words.user') }}:</strong>
                    </h6>
                    {{
                      rowData.user
                        ? rowData.user.first_name + ' ' + rowData.user.last_name
                        : '-'
                    }}
                  </td>
                </tr>
                <!-- Fila 3: Analíticas -->
                <tr class="shadow-sm">
                  <td colspan="6">
                    <h6>
                      <strong>{{ $t('common_words.analytics') }}:</strong>
                    </h6>
                    <div class="analytics-table py-2">
                      <master-table
                        :columns="getAnalyticsTableColumns()"
                        :infoTable="getAnalyticsTableData()"
                        :indexColumn="{ show: false }"
                        :showColumnStatus="false"
                        :showColumnImage="false"
                        :cellStyle="getAnalyticsCellStyle"
                      />
                    </div>
                  </td>
                </tr>
                <!-- Fila 4: Conflictos -->
                <tr v-if="hasConflicts" class="shadow-sm">
                  <td colspan="6">
                    <div class="alert alert-warning" role="alert">
                      <h6 class="mb-2">
                        <strong>
                          <i class="fa fa-exclamation-triangle"></i>
                          {{ $t('common_words.conflicts') }}:
                        </strong>
                      </h6>
                      <ul class="mb-0">
                        <li v-for="conflict in conflicts" :key="conflict">
                          {{ conflict }}
                        </li>
                      </ul>
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <card-header
            :propPagination="pagination2"
            @searchedQuery="handleSearchQuery2"
            class="mr-3 mt-4"
          >
            <template slot="between">
              <img
                v-if="hasLocationData()"
                v-tooltip.top-center="$t('common_words.geo_location_map')"
                style="width: 30px; height: 30px"
                class="pointer"
                src="/static/img/iconos/map.svg"
                :alt="$t('common_words.geo_location_icon')"
                @click="handleViewDetailMap()"
              />
              <img
                v-else
                v-tooltip.top-center="$t('common_words.no_location_defined')"
                style="
                  width: 30px;
                  height: 30px;
                  opacity: 0.5;
                  cursor: not-allowed;
                "
                src="/static/img/iconos/map.svg"
                :alt="$t('common_words.geo_location_icon')"
              />
            </template>
          </card-header>
          <master-table
            :infoTable="queriedData2"
            :columns="tableColumns2"
            :showColumnStatus="false"
          >
            <template slot="addColumnsOperations">
              <table-columns-operations
                v-if="isShow()"
                @handleView="handleViewDetail"
                :canDelete="false"
                :minWidth="100"
                :showOperationEdit="false"
              />
            </template>
          </master-table>
          <card-footer ref="cardfooter" :propPagination="pagination2" />
          <div class="row" style="padding-right: 13px; padding-left: 13px">
            <div class="col-12" v-if="isExcel()">
              <div class="text-center">
                <button
                  class="btn custom-btn-success custom-shadow-btn"
                  @click="exportToExcel"
                >
                  <em class="fa fa-file-excel-o"></em>
                  {{ $t('common_words.export_to_excel') }}
                </button>
              </div>
            </div>
          </div>
        </div>
      </card>
      <el-dialog
        v-if="isShow()"
        :title="$t('common_words.record_selected_threepoints')"
        :visible.sync="modals.read"
        width="70%"
        top="2%"
      >
        <p>
          {{ $t('common_words.selected_record_info') }}
        </p>
        <div class="card" v-if="selectedBoxData">
          <div class="card-body">
            <box-inspection-table :boxInspectionData="selectedBoxData" />
          </div>
          <footer-date-at
            class="card-footer"
            :createdAt="selectedBoxData.created_at"
            :updatedAt="selectedBoxData.updated_at"
          />
        </div>
      </el-dialog>

      <!-- Modal del Mapa -->
      <el-dialog
        :title="$t('common_words.geo_location_map')"
        :visible.sync="modals.map"
        width="80%"
        :before-close="handleCloseMap"
        class="zoom-map el-dialog-img-zoom"
      >
        <div ref="multipleMap" class="map"></div>
        <div id="toolbarDiv" class="esri-component esri-widget">
          <button
            id="distance"
            class="action-button esri-widget--button esri-interactive esri-icon-measure-line"
            style="margin-bottom: 10px"
            :title="$t('common_words.distance_measurement_tool')"
          ></button>
          <button
            id="area"
            class="action-button esri-widget--button esri-interactive esri-icon-measure-area"
            style="margin-bottom: 10px"
            :title="$t('common_words.area_measurement_tool')"
          ></button>
          <button
            id="clear"
            class="action-button esri-widget--button esri-interactive esri-icon-trash"
            style="margin-bottom: 10px"
            :title="$t('common_words.clear_measurement')"
          ></button>
        </div>
      </el-dialog>
    </div>
  </div>
</template>
<script>
import { Axios } from 'src/class/Axios.js';
import { isset } from 'src/util/Util.js';
import { MixinExport } from 'src/mixins/mixin-export';
import { MixinNotification } from 'src/mixins/mixin-notification';
import Fuse from 'fuse.js';
import BoxInspectionsTable from 'src/views/Pages/Dashboard/Quality/BoxInspection/Master/box-inspections-table.js';
import BoxInspectionsTableDetails from 'src/views/Pages/Dashboard/Quality/BoxInspection/Master/BoxInspectionsTableDetails.vue';
import Filter from 'src/components/Filter/Filters.vue';
import Formatter from 'src/class/Formatter.js';
import i18n from 'src/i18n';
import mixinMasters from 'src/util/mixinMasters';
import MixinMenu from 'src/util/mixinMenu';
import MixinPermissions from 'src/util/mixinPermissions';
import MixinValidations from 'src/mixins/forms/mixin-validations';
import MixinArcgisMap from 'src/util/mixinArcgisMap';
import moment from 'moment';
import SweetAlert from 'src/class/Alerts';
import paginationData from 'src/views/Pages/Dashboard/Quality/BoxInspection/Master/paginationData';

export default {
  components: {
    [BoxInspectionsTableDetails.name]: BoxInspectionsTableDetails,
    [Filter.name]: Filter,
  },

  data() {
    return {
      dataFilter: {
        farm_ids: null,
        location_ids: null,
        date_from: null,
        date_to: null,
        date_sel: null,
      },
      activeName: 'filter',
      tableData: [],
      tableData2: [],
      searchQuery: '',
      searchQuery2: '',
      fuseSearch2: null,
      pagination: paginationData.pagination,
      pagination2: paginationData.pagination2,
      tableColumns: [],
      valueCollapse: null,
      farms: [],
      locations: [],
      showBoxDetails: false,
      compliancePercentage: 85, // Porcentaje mínimo de cumplimiento PCMS
      // Propiedades para manejo de conflictos
      conflicts: [],
      hasConflicts: false,
      // Datos de la caja seleccionada para el diálogo de detalles
      selectedBoxData: null,
      boxUnit: {},

      // Propiedades para el mapa
      center: {
        lat: 0,
        lng: 0,
      },
      map: null,

      tableColumns2: [
        {
          prop: 'box_number',
          label: this.$t('production.box'),
          align: 'center',
          minWidth: 80,
        },
        {
          prop: 'packer',
          label: this.$t('boxinspection.packer'),
          align: 'center',
          minWidth: 100,
        },
        {
          prop: 'weight',
          label: this.$t('boxinspection.box_weight'),
          align: 'center',
          formatter: (row) => {
            return this.formatNumber(row.weight);
          },
          minWidth: 120,
        },
        {
          prop: 'total_clusters',
          label: this.$t('boxinspection.total_clusters'),
          align: 'center',
          minWidth: 120,
        },
        {
          prop: 'total_fingers',
          label: this.$t('boxinspection.total_fingers'),
          align: 'center',
          minWidth: 120,
        },
      ],
    };
  },

  computed: {
    ...paginationData.functions,
    titleFilter() {
      if (this.valueCollapse) {
        return this.valueCollapse.length === 1
          ? this.$i18n.t('uti.mixinFilter.hideFilters')
          : this.$i18n.t('uti.mixinFilter.showFilters');
      }

      return this.$i18n.t('uti.mixinFilter.hideFilters');
    },
  },

  mixins: [
    MixinPermissions,
    mixinMasters,
    MixinExport,
    MixinMenu,
    MixinNotification,
    MixinValidations,
    MixinArcgisMap,
  ],

  watch: {
    '$i18n.locale': 'setupTable',
    // Watcher para detectar conflictos cuando cambie rowData
    rowData: {
      handler(newVal) {
        if (newVal) {
          this.$nextTick(() => {
            this.detectConflicts();
          });
        }
      },
      deep: true,
    },
  },

  methods: {
    handleSearchQuery(query) {
      this.searchQuery = query;
    },

    handleSearchQuery2(query) {
      this.searchQuery2 = query;
    },

    searchFuse2(keys, data = null, threshold = 0.3) {
      this.fuseSearch2 = new Fuse(data ? data : this.tableData2, {
        useExtendedSearch: true,
        threshold: threshold,
        keys: keys,
      });
    },

    handleChangeSelected(data) {
      this.$set(this.dataFilter, data.name, data.selects);
    },

    exportToExcel() {
      // Verificar que tenemos rowData (inspección seleccionada)
      if (!this.rowData) {
        SweetAlert.warning(this.$t('common_words.unavailable_data'));
        return;
      }

      // Formatear fecha a YYYY-MM-DD
      const formattedDate = this.rowData.date_save
        ? moment(this.rowData.date_save).format('YYYY-MM-DD')
        : 'N/A';

      // Obtener código y nombre de la finca
      const farmCode =
        this.rowData.farm && this.rowData.farm.code
          ? this.rowData.farm.code
          : 'N/A';
      const farmName =
        this.rowData.farm && this.rowData.farm.name
          ? this.rowData.farm.name
          : 'N/A';
      const farmInfo = `${farmCode} - ${farmName}`;

      // Obtener ubicación de inspección
      const locationName =
        this.rowData.location_inspection &&
        this.rowData.location_inspection.name
          ? this.rowData.location_inspection.name
          : 'N/A';

      // Crear nombre del archivo con el mismo formato que los puntos del mapa
      const nameFile = `${formattedDate}, ${farmInfo}, ${locationName}.xlsx`;

      const data = {
        route: 'quality/boxinspections/excel',
        name_file: nameFile,
        data: this.tableData2,
      };

      this.Excel(data, 'POST', true)
        .then(() => {
          this.showDownloadNotification();
        })
        .catch((error) => {
          this.showHideLoading();
          SweetAlert.warning(error.response.data.message);
        });
    },

    handleFilter(data) {
      this.tableData = [];
      this.tableData2 = [];
      this.boxUnit = {};
      this.showBoxDetails = false;
      this.rowData = null;
      this.dataFilter = {
        ...this.dataFilter,
        date_from: data.datei,
        date_to: data.datef,
        date_sel: data.bySel,
      };

      if (!isset(this.dataFilter.farm_ids)) {
        return this.validationInputsRequired('farm-id');
      } else {
        this.getData();
      }
    },

    handleViewDetails() {
      this.showBoxDetails = !this.showBoxDetails;

      // Si se están ocultando los detalles, limpiar rowData para que aparezca el botón de visualizar
      if (!this.showBoxDetails) {
        this.rowData = null;
      }
    },

    handleView(_, row) {
      this.showHideLoading(true);
      this.boxUnit = {};
      this.rowData = {
        ...row,
      };

      this.tableData2 = row.box_inspection_boxes;
      this.boxUnit = row.box;

      // Configurar búsqueda para la segunda tabla
      this.searchFuse2(
        this.tableColumns2.map((column) => {
          return column.prop;
        })
      );
      //this.searchFuse2(['box_code', 'variety', 'quality_grade', 'weight', 'packer']);
      this.showBoxDetails = true;

      // Detectar conflictos después de cargar los datos
      this.$nextTick(() => {
        this.detectConflicts();
      });

      setTimeout(() => {
        this.showHideLoading();
      }, 500);
    },

    handleViewDetail(_, row) {
      this.selectedBoxData = {
        ...row,
        boxUnit: this.boxUnit,
      };
      this.modals['read'] = true;
    },

    getData() {
      this.showHideLoading(true);
      let data = { ...this.dataFilter, route: 'quality/boxinspections/filter' };

      if (data.date_sel === 'Año') {
        data.date_from += '-01-01';
        data.date_to += '-12-31';
      }

      Axios.postMasters(data)
        .then((response) => {
          this.tableData = response.data.data;
          if (this.tableData.length == 0) {
            SweetAlert.warning(i18n.t('common_words.unavailable_data'));
          } else {
            this.searchFuse(
              this.tableColumns.map((column) => {
                return column.prop;
              })
            );
            this.pagination.perPage = 5;
            this.pagination.currentPage = 1;
            this.searchQuery = '';
          }

          this.showHideLoading();
        })
        .catch((error) => {
          this.showHideLoading();
          SweetAlert.warning(error.response.data.message);
        });
    },

    handleCollapse(val) {
      this.valueCollapse = val;
    },

    handleEdit(_, row) {
      sessionStorage.setItem('editForm', JSON.stringify({ ...row }));
      this.$router.push({
        path: '/quality/boxinspections/edit',
      });
    },

    handleDelete(_, row) {
      const formattedDate = moment(row.date_save).format('YYYY-MM-DD');
      const farmName = row.farm ? row.farm.name : 'N/A';
      const deleteMessage = `${formattedDate} - ${farmName}`;

      SweetAlert.delete(deleteMessage).then((result) => {
        if (result.value) {
          this.deleteBoxInspection(row);
          this.tableData2 = [];
          this.showBoxDetails = false;
          this.rowData = null;
          this.boxUnit = {};
        }
      });
    },

    deleteBoxInspection(row) {
      if (this.isDelete()) {
        this.showHideLoading(true);
        const boxInspectionForm = {
          id: row.id,
          route: 'quality/boxinspections',
        };
        Axios.destroyMaster(boxInspectionForm)
          .then((response) => {
            this.modifyTable(2, boxInspectionForm.id, response);
            this.showHideLoading();
          })
          .catch((error) => {
            this.showHideLoading();
            this.showMessageErrors(error);
          });
      } else {
        this.showMessageAccess();
      }
    },

    setupTable() {
      const { Table } = BoxInspectionsTable();
      this.tableColumns = Table.tableColumns;
      this.pagination = { ...Table.pagination };
    },

    handleViewSamplesMap() {
      if (!this.tableData || this.tableData.length === 0) {
        SweetAlert.warning(this.$t('common_words.unavailable_data'));
        return;
      }

      // Filtrar solo los registros que tienen datos de ubicación
      const validLocations = this.tableData.filter(
        (item) =>
          item.latitude &&
          item.longitude &&
          !isNaN(parseFloat(item.latitude)) &&
          !isNaN(parseFloat(item.longitude))
      );

      if (validLocations.length === 0) {
        SweetAlert.warning(this.$t('boxinspection.no_locations_defined'));
        return;
      }

      this.modals.map = true;
      this.showHideLoading(true);

      let points = [];

      // Crear puntos para cada inspección con datos de ubicación
      validLocations.forEach((inspection, index) => {
        let pll = new Object();
        pll.lat = parseFloat(inspection.latitude);
        pll.lng = parseFloat(inspection.longitude);

        // Formatear fecha a YYYY-MM-DD
        const formattedDate = inspection.date_save
          ? moment(inspection.date_save).format('YYYY-MM-DD')
          : 'N/A';

        // Obtener código y nombre de la finca
        const farmCode =
          inspection.farm && inspection.farm.code
            ? inspection.farm.code
            : 'N/A';
        const farmName =
          inspection.farm && inspection.farm.name
            ? inspection.farm.name
            : 'N/A';
        const farmInfo = `${farmCode} - ${farmName}`;

        // Obtener ubicación de inspección
        const locationName =
          inspection.location_inspection && inspection.location_inspection.name
            ? inspection.location_inspection.name
            : 'N/A';

        // Crear título con la estructura solicitada
        pll.name = `${formattedDate}, ${farmInfo}, ${locationName}`;
        points.push(pll);
      });

      // Configurar el centro del mapa basado en todos los puntos
      this.center = this.getCenterExtend(points);

      setTimeout(() => {
        this.loadBaseMap(
          null, // No usar KML, solo puntos
          true, // Mostrar herramientas de medición
          true, // Mostrar lista de capas
          this.$refs.multipleMap,
          points,
          14 // Zoom más amplio para ver todos los puntos
        );
        // Ajustar posición del toolbar del mapa
        const toolbarDiv = document.getElementById('toolbarDiv');
        if (toolbarDiv) {
          toolbarDiv.style = 'top: 16%;right: 18px;';
        }
        this.showHideLoading();
      }, 10);
    },

    handleViewDetailMap() {
      if (!this.hasLocationData()) {
        SweetAlert.warning(this.$t('boxinspection.no_locations_defined'));

        return;
      }

      this.modals.map = true;
      this.showHideLoading(true);
      let points = [];

      this.center.lat = this.rowData.latitude
        ? parseFloat(this.rowData.latitude)
        : this.center.lat;
      this.center.lng = this.rowData.longitude
        ? parseFloat(this.rowData.longitude)
        : this.center.lng;

      let pll = new Object();
      pll.lat = parseFloat(this.rowData.latitude);
      pll.lng = parseFloat(this.rowData.longitude);

      // Formatear fecha a YYYY-MM-DD
      const formattedDate = this.rowData.date_save
        ? moment(this.rowData.date_save).format('YYYY-MM-DD')
        : 'N/A';

      // Obtener código y nombre de la finca
      const farmCode =
        this.rowData.farm && this.rowData.farm.code
          ? this.rowData.farm.code
          : 'N/A';
      const farmName =
        this.rowData.farm && this.rowData.farm.name
          ? this.rowData.farm.name
          : 'N/A';
      const farmInfo = `${farmCode} - ${farmName}`;

      // Obtener ubicación de inspección
      const locationName =
        this.rowData.location_inspection &&
        this.rowData.location_inspection.name
          ? this.rowData.location_inspection.name
          : 'N/A';

      // Crear título con la estructura solicitada
      pll.name = `${formattedDate}, ${farmInfo}, ${locationName}`;
      points.push(pll);

      setTimeout(() => {
        this.loadBaseMap(
          this.rowData.farm_id,
          true,
          true,
          this.$refs.multipleMap,
          points,
          19
        );
        // Ajustar posición del toolbar del mapa
        const toolbarDiv = document.getElementById('toolbarDiv');
        if (toolbarDiv) {
          toolbarDiv.style = 'top: 16%;right: 18px;';
        }
        this.showHideLoading();
      }, 10);
    },

    handleCloseMap() {
      this.modals.map = false;
      // Limpiar el mapa si existe
      if (this.map) {
        this.map.destroy();
        this.map = null;
      }
    },

    hasLocationData() {
      if (!this.rowData) {
        return false;
      }

      const { latitude, longitude } = this.rowData;

      return isset(latitude) && isset(longitude);
    },

    getBoxDetailsTableData() {
      if (!this.rowData || !this.rowData.box_inspection_boxes) {
        return [];
      }
      return this.rowData.box_inspection_boxes;
    },

    formatNumber(value) {
      return Formatter.formatNumber(Number(value));
    },

    formatDate(date) {
      return moment(date).format('YYYY-MM-DD');
    },

    getAnalyticsTableColumns() {
      const weightUnit =
        this.rowData.box && this.rowData.box.unit_tara_weight
          ? this.rowData.box.unit_tara_weight
          : 'lb';

      return [
        {
          label: this.$t('production.box'),
          prop: 'number_box',
          align: 'center',
          minWidth: 50,
        },
        {
          label:
            this.$t('common_words.weight') +
            ' (' +
            weightUnit +
            ')' +
            this.getMinWeightText(),
          prop: 'weight',
          align: 'center',
          formatter: (row) => {
            return this.formatNumber(row.weight);
          },
          minWidth: 50,
        },
        {
          label: this.$t('boxinspection.pcms') + ' (%)' + this.getMinPCMSText(),
          prop: 'pcms',
          align: 'center',
          formatter: (row) => {
            return this.formatNumber(row.pcms);
          },
          minWidth: 50,
        },
        {
          label:
            this.$t('boxinspection.total_underweight_fingers') +
            this.getMinUnderweightText(),
          prop: 'total_underweight_fingers',
          align: 'center',
          formatter: (row) => {
            return row.total_underweight_fingers;
          },
          minWidth: 50,
        },
      ];
    },

    getAnalyticsTableData() {
      const data = [];

      if (!this.rowData.box_inspection_boxes) {
        return data;
      }

      let totalPcms = 0;
      let totalUnderweightFingers = 0;
      let totalWeight = 0;

      this.rowData.box_inspection_boxes.forEach((box, index) => {
        // Calcular PCMS
        const pcms = this.calculatePCMS(box);

        // Calcular gajos bajo peso (asumiendo que se calcula basado en clusters < 2lb)
        const underweightFingers = this.calculateUnderweightFingers(box);

        // Peso de la caja
        const weight = parseFloat(box.weight) || 0;

        // Acumular totales
        totalPcms += pcms;
        totalUnderweightFingers += underweightFingers;
        totalWeight += weight;

        data.push({
          number_box: box.box_number,
          weight: weight,
          pcms: pcms,
          total_underweight_fingers: underweightFingers,
        });
      });

      // Agregar fila de totales
      const averagePcms =
        this.rowData.box_inspection_boxes.length > 0
          ? totalPcms / this.rowData.box_inspection_boxes.length
          : 0;

      const averageWeight =
        this.rowData.box_inspection_boxes.length > 0
          ? totalWeight / this.rowData.box_inspection_boxes.length
          : 0;

      data.push({
        number_box: '',
        weight: averageWeight,
        pcms: averagePcms,
        total_underweight_fingers: totalUnderweightFingers,
        isTotal: true,
      });

      return data;
    },

    calculatePCMS(box) {
      const totalClusters = box.total_clusters || 0;

      if (totalClusters === 0) {
        return 100; // Si no hay clusters, PCMS es 100%
      }

      // Calcular clusters descontables basado en defectos
      const discountableClusters = this.calculateDiscountableClusters(box);

      // Aplicar fórmula PCMS: ((Total Clusters - Cant. Cluster descontables) / Total Clusters) * 100
      const pcms =
        ((totalClusters - discountableClusters) / totalClusters) * 100;

      // Limitar a 2 decimales y asegurar que no sea negativo
      return Math.max(0, Math.round(pcms * 100) / 100);
    },

    calculateDiscountableClusters(box) {
      let discountableClusters = 0;

      if (box.box_inspection_defects && box.box_inspection_defects.length > 0) {
        box.box_inspection_defects.forEach((defect) => {
          // Asumiendo que todos los defectos son descontables por defecto
          // En un caso real, deberías verificar si el defecto tiene la propiedad discountable
          discountableClusters += defect.number_clusters || 0;
        });
      }

      return discountableClusters;
    },

    calculateUnderweightFingers(box) {
      // Calcular gajos bajo peso basado en los clusters con peso < 2lb
      let underweightCount = 0;

      if (
        box.box_inspection_clusters &&
        box.box_inspection_clusters.length > 0
      ) {
        for (const cluster of box.box_inspection_clusters) {
          const weight = parseFloat(cluster.weight) || 0;
          if (weight < 2.0) {
            underweightCount++;
          }
        }
      }

      return underweightCount;
    },

    getMinWeightText() {
      // Obtener el peso mínimo de la caja
      const minWeight =
        this.rowData.box && this.rowData.box.min_weight
          ? this.rowData.box.min_weight
          : null;

      if (minWeight) {
        const weightUnit =
          this.rowData.box && this.rowData.box.unit_tara_weight
            ? this.rowData.box.unit_tara_weight
            : 'lb';

        return ` (Min: ${minWeight} ${weightUnit})`;
      }

      return '';
    },

    getMinPCMSText() {
      // Mostrar el porcentaje mínimo de cumplimiento requerido
      if (this.compliancePercentage > 0) {
        return ` (Min: ${this.compliancePercentage}%)`;
      }

      return '';
    },

    getMinUnderweightText() {
      // Mostrar el límite mínimo de gajos bajo peso (actualmente fijo en 2 lb)
      return ' (Min: 2 lb)';
    },

    getAnalyticsCellStyle({ row, column, rowIndex, columnIndex }) {
      // Si es la fila de totales, no aplicar color
      const columnProp = column.property;
      if (row.isTotal && columnProp === 'pcms') {
        return this.getPCMSCellStyle(row);
      } else if (row.isTotal) {
        return {};
      }

      // Aplicar colores según la columna
      if (columnProp === 'weight') {
        return this.getWeightCellStyle(row);
      } else if (columnProp === 'pcms') {
        return this.getPCMSCellStyle(row);
      } else if (columnProp === 'total_underweight_fingers') {
        return this.getUnderweightFingersCellStyle(row);
      }

      return {};
    },

    getWeightCellStyle(row) {
      // Obtener el peso mínimo de la caja
      const minWeight =
        this.rowData.box && this.rowData.box.min_weight
          ? parseFloat(this.rowData.box.min_weight)
          : 0;

      const currentWeight = parseFloat(row.weight) || 0;

      // Si el peso actual es mayor o igual al mínimo, verde claro, sino rojo claro
      if (currentWeight >= minWeight) {
        return {
          backgroundColor: '#d4edda',
          color: '#155724',
        };
      } else {
        return {
          backgroundColor: '#f8d7da',
          color: '#721c24',
        };
      }
    },

    getPCMSCellStyle(row) {
      const currentPcms = parseFloat(row.pcms) || 0;

      // Si el PCMS es mayor o igual al porcentaje mínimo, verde claro, sino rojo claro
      if (currentPcms >= this.compliancePercentage) {
        return {
          backgroundColor: '#d4edda',
          color: '#155724',
        };
      } else {
        return {
          backgroundColor: '#f8d7da',
          color: '#721c24',
        };
      }
    },

    getUnderweightFingersCellStyle(row) {
      const currentUnderweightFingers =
        parseInt(row.total_underweight_fingers) || 0;

      // Si no hay gajos bajo peso, verde claro, sino rojo claro
      if (currentUnderweightFingers === 0) {
        return {
          backgroundColor: '#d4edda',
          color: '#155724',
        };
      } else {
        return {
          backgroundColor: '#f8d7da',
          color: '#721c24',
        };
      }
    },

    // Métodos para detección de conflictos
    detectConflicts() {
      this.conflicts = [];
      this.hasConflicts = false;

      if (!this.rowData || !this.rowData.box_inspection_boxes) {
        return;
      }

      // Evaluación 1: Verificar si todas las cajas están por debajo del peso mínimo
      if (this.checkAllBoxesUnderMinWeight()) {
        this.conflicts.push(
          'Todas las cajas están por debajo del peso mínimo requerido'
        );
        this.hasConflicts = true;
      }

      // Evaluación 2: Verificar si el promedio de PCMS está por debajo del parametrizado
      if (this.checkAveragePCMSBelowCompliance()) {
        this.conflicts.push(
          'El promedio de PCMS está por debajo del porcentaje de cumplimiento requerido'
        );
        this.hasConflicts = true;
      }

      // Evaluación 3: Verificar si hay gajos/clusters bajo peso
      if (this.checkUnderweightClusters()) {
        this.conflicts.push('Hay gajos o clusters con peso inferior a 2 lb');
        this.hasConflicts = true;
      }
    },

    checkAllBoxesUnderMinWeight() {
      if (!this.rowData.box || !this.rowData.box.min_weight) {
        return false;
      }

      const minWeight = parseFloat(this.rowData.box.min_weight);

      for (const box of this.rowData.box_inspection_boxes) {
        const weight = parseFloat(box.weight) || 0;
        if (weight >= minWeight) {
          return false; // Si al menos una caja cumple el peso mínimo, no hay conflicto
        }
      }

      return true; // Todas las cajas están por debajo del peso mínimo
    },

    checkAveragePCMSBelowCompliance() {
      if (this.compliancePercentage === 0) {
        return false;
      }

      const analyticsData = this.getAnalyticsTableData();
      const totalRow = analyticsData.find((row) => row.isTotal);

      if (!totalRow) {
        return false;
      }

      return totalRow.pcms < this.compliancePercentage;
    },

    checkUnderweightClusters() {
      // Verificar si hay clusters con peso < 2 lb en los datos de box_inspection_clusters
      for (const box of this.rowData.box_inspection_boxes) {
        if (
          box.box_inspection_clusters &&
          box.box_inspection_clusters.length > 0
        ) {
          for (const cluster of box.box_inspection_clusters) {
            const weight = parseFloat(cluster.weight) || 0;
            if (weight < 2.0) {
              return true; // Encontró al menos un cluster bajo peso
            }
          }
        }
      }

      return false; // No hay clusters bajo peso
    },
  },

  created() {
    if (this.isIndex()) {
      this.showHideLoading(true);
      this.setupTable();
      Promise.all([
        Axios.getMasters('farms/farms/onlyfruit'),
        Axios.getMasters('quality/locationinspections'),
      ])
        .then(([responseFarm, responseLocation]) => {
          this.farms = this.concatAll(
            responseFarm.data.data.map((farm) => ({
              ...farm,
              name: `${farm.code} - ${farm.name}`,
            }))
          );
          this.locations = this.concatAll(responseLocation.data.data);
          this.showHideLoading();
        })
        .catch((error) => {
          this.showHideLoading();
          this.showMessageErrors(error);
        });
    } else {
      this.showHideLoading();
    }
  },

  mounted() {
    this.selectedItemOnMenu('quality');
  },

  beforeDestroy() {
    this.deselectedItemOnMenu('quality');
  },
};
</script>
